import { MaintenanceWindowGridController } from '../controller/MaintenanceWindowGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { GridTitleConfig } from '../../../grid/uiElements/gridViewTitle/types';

export class MaintenanceWindowGridWebComponent extends BaseWebComponentElement {
  public controller!: MaintenanceWindowGridController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowGridController,
    });
  }

  set sideNavFilters(extraParams) {
    this.controller.view.dom.$gridView.extraParams = {};

    if (Object.keys(extraParams).length !== 0 && extraParams.constructor === Object) {
      this.controller.view.dom.$gridView.extraParams = {
        ...this.controller.view.dom.$gridView.extraParams,
        ...extraParams,
      };
    }

    this.controller.view.dom.$gridView.propertiesSet = true;
  }

  set gridTitle(text: string) {
    this.controller.view.dom.$gridView.propertiesSet = false;
    this.controller.view.dom.$gridView.titleConfig = new GridTitleConfig(text);
    this.controller.view.dom.$gridView.propertiesSet = true;
  }
}
